import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminNavigation from './AdminNavigation';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function UpdatePageData() {
    const [bannerurl, setBannerurl] = useState('');
    const [bannertitle, setBannertitle] = useState('');
    const [bannerdesc, setBannerdesc] = useState('');
    const [pagetitle, setPagetitle] = useState('');
    const [pagedesc, setPagedesc] = useState('');
    const [template, setTemplate] = useState('');
    const [slug, setSlug] = useState('');
    const [sort, setSort] = useState('');
    const [top_menu, setTopmenu] = useState('');
    const [id, setID] = useState(null);
    const [pageImage, setpageImage] = useState('');
    const [success, setSuccess] = useState(false);
    const [aiData, setAiData] = useState({});
    const [loadingAI, setLoadingAI] = useState(false);
    const [copiedField, setCopiedField] = useState([]);
    const [allCopied, setAllCopied] = useState(false);

    useEffect(() => {
        setID(localStorage.getItem('ID'));
        setBannerurl(localStorage.getItem('Banner URL'));
        setBannertitle(localStorage.getItem('Banner Title'));
        setBannerdesc(localStorage.getItem('Banner Description'));
        setPagetitle(localStorage.getItem('Page Title'));
        setPagedesc(localStorage.getItem('Page Description'));
        setTemplate(localStorage.getItem('Page Template'));
        setSlug(localStorage.getItem('Page Slug'));
        setSort(localStorage.getItem('Page Sort'));
        setTopmenu(localStorage.getItem('Top menu'));
        setpageImage(localStorage.getItem('Page Image'));
    }, []);

    const TOKEN = localStorage.getItem('adminToken');

    const updateSelectedPageData = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/pages/updatepage/${id}`, {
                bannerurl,
                bannertitle,
                bannerdesc,
                pagetitle,
                pagedesc,
                template,
                slug,
                sort,
                top_menu,
                pageImage
            }, {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });
            setSuccess(true);
            setTimeout(() => {
                window.location.href = "/admin/pages";
            }, 5000);
        } catch (error) {
            console.log(error, 'ERRRRRRORRRRR');
        }
    }
    useEffect(() => {
        if (slug) {
            fetchAISuggestions();
        }
    }, [slug]);

    const fetchAISuggestions = async () => {
        try {
            setLoadingAI(true);
            setAllCopied(false);
            setCopiedField([]); // Reset copied fields when fetching new suggestions

            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}/chatbot/getFieldsSuggestions`,
                {
                    page_name: slug   // using your existing state
                },
                {
                    headers: {
                        Authorization: `Bearer ${TOKEN}`
                    }
                }
            );

            const formattedData = {};
            res.data.suggestions.forEach(item => {
                formattedData[item.field] = item.suggestion;
            });

            setAiData(formattedData);
        } catch (err) {
            console.log(err);
        } finally {
            setLoadingAI(false);
        }
    };

    const handleAcceptAll = () => {
        if (!aiData) return;

        setBannertitle(aiData.bannertitle || bannertitle);
        setBannerdesc(aiData.bannerdesc || bannerdesc);
        setPagetitle(aiData.pagetitle || pagetitle);
        setPagedesc(aiData.pagedesc || pagedesc);
        setAllCopied(true);
    };

    const handleAcceptField = (field, value) => {
        if (!value) return;

        switch (field) {
            case "bannertitle":
                setBannertitle(value);
                break;
            case "bannerdesc":
                setBannerdesc(value);
                break;
            case "pagetitle":
                setPagetitle(value);
                break;
            case "pagedesc":
                setPagedesc(value);
                break;
            case "bannerurl":
                setBannerurl(value);
                break;
            case "slug":
                setSlug(value);
                break;
            case "template":
                setTemplate(value);
                break;
            case "sort":
                setSort(value);
                break;
            case "top_menu":
                setTopmenu(value);
                break;
            case "pageImage":
                setpageImage(value);
                break;
            default:
                break;
        }

        // Show indicator
        setCopiedField(prev => [...new Set([...prev, field])]);
    };

    return (
        <div id="wrapper" className="toggled">
            <AdminNavigation />
            <div id="page-content-wrapper">
                <div className="container">
                    <div className="row">
                        <h4>Update</h4>
                        {/* AI BUTTONS */}
                        <div className="mb-3 d-flex gap-2">
                            <button
                                type="button"
                                className="btn btn-warning"
                                onClick={fetchAISuggestions}
                            >
                                {loadingAI ? "Generating..." : "Regenerate AI suggestion"}
                            </button>

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleAcceptAll}
                            >
                                Accept All
                            </button>
                        </div>
                        {success && <div className="alert alert-success">Page updated successfully! Redirecting...</div>}
                        <form onSubmit={updateSelectedPageData}>
                            <img src={bannerurl} alt="Banner" />
                            <div className="mb-3 mt-3">
                                <label htmlFor="bannerurl" className="form-label">Banner URL:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="bannerurl"
                                    placeholder="Enter Banner URL"
                                    name="bannerurl"
                                    value={bannerurl}
                                    onChange={(e) => setBannerurl(e.target.value)}
                                    required
                                />
                            </div>
                            {/* Banner Title */}
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label>Banner Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={bannertitle}
                                        onChange={(e) => setBannertitle(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="text-success d-flex justify-content-between">
                                        AI Suggestion for Banner Title{" "}
                                        {loadingAI && <span style={{ color: 'black' }}>- Generating...</span>}

                                        {/* ICON BUTTON */}
                                        <span
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                                handleAcceptField("bannertitle", aiData?.bannertitle)
                                            }
                                            title="Copy to field"
                                        >
                                            {copiedField.includes("bannertitle") || allCopied ? (
                                                <span style={{ color: "green" }}>✔</span>
                                            ) : (
                                                <i className="fas fa-clipboard"></i>
                                            )}
                                        </span>
                                    </label>

                                    <div className="border p-2 bg-light">
                                        {loadingAI
                                            ? "Generating suggestion...."   // hide text while loading
                                            : (aiData?.bannertitle || "No suggestion")}
                                    </div>
                                </div>
                            </div>
                            {/* Banner Description */}
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label>Banner Description</label>
                                    <ReactQuill
                                        value={bannerdesc}
                                        onChange={setBannerdesc}
                                        theme="snow"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="text-success d-flex justify-content-between">
                                        AI Suggestion for Banner Description{" "}
                                        {loadingAI && <span style={{ color: 'black' }}>- Generating...</span>}

                                        {/* ICON BUTTON */}
                                        <span
                                            style={{
                                                cursor: loadingAI ? "not-allowed" : "pointer",
                                                opacity: loadingAI ? 0.5 : 1
                                            }}
                                            onClick={() => {
                                                if (!loadingAI) {
                                                    handleAcceptField("bannerdesc", aiData?.bannerdesc);
                                                }
                                            }}
                                            title="Copy to field"
                                        >
                                            {copiedField.includes("bannerdesc") || allCopied ? (
                                                <span style={{ color: "green" }}>✔</span>
                                            ) : (
                                                <i className="fas fa-clipboard"></i>
                                            )}
                                        </span>
                                    </label>

                                    <div className="border p-2 bg-light">
                                        {loadingAI
                                            ? "Generating suggestion..."
                                            : (aiData?.bannerdesc || "No suggestion")}
                                    </div>
                                </div>
                            </div>
                            {/* Page Title */}
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label>Page Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={pagetitle}
                                        onChange={(e) => setPagetitle(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="text-success d-flex justify-content-between">
                                        AI Suggestion for Page Title{" "}
                                        {loadingAI && <span style={{ color: "black" }}>- Generating...</span>}

                                        {/* ICON BUTTON */}
                                        <span
                                            style={{
                                                cursor: loadingAI ? "not-allowed" : "pointer",
                                                opacity: loadingAI ? 0.5 : 1
                                            }}
                                            onClick={() => {
                                                if (!loadingAI) {
                                                    handleAcceptField("pagetitle", aiData?.pagetitle);
                                                }
                                            }}
                                            title="Copy to field"
                                        >
                                            {copiedField.includes("pagetitle") || allCopied ? (
                                                <span style={{ color: "green" }}>✔</span>
                                            ) : (
                                                <i className="fas fa-clipboard"></i>
                                            )}
                                        </span>
                                    </label>

                                    <div className="border p-2 bg-light">
                                        {loadingAI
                                            ? "Generating suggestion..."
                                            : (aiData?.pagetitle || "No suggestion")}
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3 mt-3">
                                <label htmlFor="slug" className="form-label">Page Slug:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="slug"
                                    placeholder="Enter Page Slug"
                                    name="slug"
                                    value={slug}
                                    onChange={(e) => setSlug(e.target.value)}
                                    required
                                />
                            </div>
                            {/* Page Description */}
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label>Page Description</label>
                                    <ReactQuill
                                        value={pagedesc}
                                        onChange={setPagedesc}
                                        theme="snow"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="text-success d-flex justify-content-between">
                                        AI Suggestion for Page Description{" "}
                                        {loadingAI && <span style={{ color: "black" }}>- Generating...</span>}

                                        {/* ICON BUTTON */}
                                        <span
                                            style={{
                                                cursor: loadingAI ? "not-allowed" : "pointer",
                                                opacity: loadingAI ? 0.5 : 1
                                            }}
                                            onClick={() => {
                                                if (!loadingAI) {
                                                    handleAcceptField("pagedesc", aiData?.pagedesc);
                                                }
                                            }}
                                            title="Copy to field"
                                        >
                                            {copiedField.includes("pagedesc") || allCopied ? (
                                                <span style={{ color: "green" }}>✔</span>
                                            ) : (
                                                <i className="fas fa-clipboard"></i>
                                            )}
                                        </span>
                                    </label>

                                    <div className="border p-2 bg-light">
                                        {loadingAI ? (
                                            "Generating suggestion..."
                                        ) : (
                                            aiData?.pagedesc || "No suggestion"
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="template" className="form-label">Page Template:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="template"
                                    placeholder="Enter Page Template"
                                    name="template"
                                    value={template}
                                    onChange={(e) => setTemplate(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="sort" className="form-label">Page Sorting:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="sort"
                                    placeholder="Enter Page Sort"
                                    name="sort"
                                    value={sort}
                                    onChange={(e) => setSort(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="top_menu" className="form-label">Page Menu Position:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="top_menu"
                                    placeholder="Enter Page Menu Position"
                                    name="top_menu"
                                    value={top_menu}
                                    onChange={(e) => setTopmenu(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="pageImage" className="form-label">Page Image:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="pageImage"
                                    placeholder="Enter Page Image"
                                    name="pageImage"
                                    value={pageImage}
                                    onChange={(e) => setpageImage(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary register_btn mb-4">Update</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdatePageData;
